import { unstable_useBlocker, useBeforeUnload } from 'react-router-dom';

export const useNavigationBlocker = (when: boolean) => {
  const blocker = unstable_useBlocker(when);

  // eslint-disable-next-line consistent-return
  useBeforeUnload((event) => {
    if (when) {
      const e = event || window.event;
      e.preventDefault();
      if (e) {
        e.returnValue = '';
      }
      return '';
    }
  });

  return {
    isBlocking: blocker.state === 'blocked',
    resetBlocking: () => {
      blocker.reset?.();
    },
    proceedNavigation: () => {
      blocker.proceed?.();
    },
  };
};
